module.exports = __webpack_public_path__ + "src/assets/img/profile_w.b3a01399.svg";